interface LiveMatchCardProps {
  match: {
    id: string;
    homeTeam: string;
    awayTeam: string;
    homeLogo: string;
    awayLogo: string;
    homeScore: number;
    awayScore: number;
    status: string;
    minute: string;
    league: string;
    viewers: string;
  };
}

export default function LiveMatchCard({ match }: LiveMatchCardProps) {
  const statusColors: Record<string, string> = {
    live: "bg-accent-500",
    upcoming: "bg-secondary-500",
    finished: "bg-foreground-400",
  };

  const statusLabels: Record<string, string> = {
    live: "直播中",
    upcoming: "即将开始",
    finished: "已结束",
  };

  return (
    <div className="bg-background-50 rounded-2xl border border-background-200/70 p-5 hover:border-primary-200 transition-all cursor-pointer group">
      <div className="flex items-center justify-between mb-4">
        <span className="text-xs text-foreground-500">{match.league}</span>
        <div className="flex items-center gap-1.5">
          <span className={`w-2 h-2 rounded-full ${statusColors[match.status] || "bg-foreground-400"} ${match.status === "live" ? "animate-pulse" : ""}`}></span>
          <span className="text-xs font-medium text-foreground-700">{statusLabels[match.status]}</span>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <div className="flex flex-col items-center gap-2 flex-1">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden bg-background-100">
            <img src={match.homeLogo} alt={match.homeTeam} className="w-full h-full object-cover" />
          </div>
          <span className="text-sm font-semibold text-foreground-900 text-center whitespace-nowrap">{match.homeTeam}</span>
        </div>

        <div className="flex flex-col items-center gap-1 px-3">
          <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            {match.status === "upcoming" ? "VS" : `${match.homeScore} : ${match.awayScore}`}
          </div>
          <span className={`text-xs font-medium ${match.status === "live" ? "text-accent-600" : "text-foreground-500"}`}>
            {match.minute}
          </span>
        </div>

        <div className="flex flex-col items-center gap-2 flex-1">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden bg-background-100">
            <img src={match.awayLogo} alt={match.awayTeam} className="w-full h-full object-cover" />
          </div>
          <span className="text-sm font-semibold text-foreground-900 text-center whitespace-nowrap">{match.awayTeam}</span>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-center gap-1 text-xs text-foreground-500">
        <i className="ri-eye-line"></i>
        <span>{match.viewers} 观看</span>
      </div>
    </div>
  );
}